<div class="desc">
    Search for any domains in our database matching the specified criteria.
</div>

<div class="row">
    <mat-form-field>
        <mat-label>Domain name</mat-label>
        <input matInput
               placeholder="Partial domain name"
               [(ngModel)]="partialName"
               (keydown.enter)="searchDomains()">
    </mat-form-field>

    <mat-checkbox [checked]="removedChecked()"
                  [indeterminate]="removedIndeterminate()"
                  [matTooltip]="removedTooltip()"
                  (click)="cycleRemovedState()">Removed from registry</mat-checkbox>

    <mat-checkbox [checked]="expiredChecked()"
                  [indeterminate]="expiredIndeterminate()"
                  [matTooltip]="expiredTooltip()"
                  (click)="cycleExpiredState()">Expired</mat-checkbox>
</div>

<div class="row">
    <mat-form-field id="status_field">
        <mat-label>EPP Status</mat-label>
        <mat-select [(value)]="selectedEppStatus">
            <mat-option [value]="null">
                (any)
            </mat-option>
            @for (s of eppStatuses; track s) {
                <mat-option [value]="s">
                    {{s}}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>NS group</mat-label>
        <mat-select [(value)]="selectedNsGroup">
            <mat-option [value]="null">
                (any)
            </mat-option>
            @for (g of nsGroups(); track g.name) {
                <mat-option [value]="g.name">
                    {{g.name}}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Flags</mat-label>
        <mat-select [(value)]="selectedFlag">
            <mat-option [value]="null">
                (any)
            </mat-option>
            @for (f of flags(); track f) {
                <mat-option [value]="f">
                    {{f}}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>

<div class="row">
    <button mat-raised-button
            color="primary"
            (click)="searchDomains()">Search</button>

    <button mat-raised-button
            color="primary"
            (click)="clearSearch()">Clear</button>

    <button mat-raised-button
            color="primary"
            [disabled]="totalMatches() <= 0"
            [matMenuTriggerFor]="exportMenu">Export</button>
    <mat-menu #exportMenu="matMenu">
        <button mat-menu-item (click)="exportTxt()">Domain names (.txt)</button>
        <button mat-menu-item (click)="exportCsvNoHeaders()">CSV (no headers)</button>
        <button mat-menu-item (click)="exportCsvWithHeaders()">CSV (with headers)</button>
    </mat-menu>
</div>

@if (this.totalMatches() > 0) {
    <div class="paginator_row">
        <mat-paginator #paginator
                       [length]="this.totalMatches()"
                       [showFirstLastButtons]="true"
                       [pageIndex]="pageIndex()"
                       [pageSize]="pageSize()"
                       [pageSizeOptions]="pageSizeOptions()"
                       (page)="onPageChange($event)"></mat-paginator>
    </div>

    <div id="table_scroller">
        <table mat-table [dataSource]="matchingDomains()">

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Domain name</th>
                <td mat-cell *matCellDef="let domain"
                    [innerHTML]="domain.name"
                    class="link"
                    matTooltip="Go to domain page"
                    matTooltipPosition="before"
                    (click)="goToDomain(domain.name)"
                ></td>
            </ng-container>

            <ng-container matColumnDef="removed">
                <th mat-header-cell *matHeaderCellDef>Removed</th>
                <td mat-cell *matCellDef="let domain" [innerHTML]="!domain.in_registry? '&check;' : ''"></td>
            </ng-container>

            <ng-container matColumnDef="expired">
                <th mat-header-cell *matHeaderCellDef>Expired</th>
                <td mat-cell *matCellDef="let domain" [innerHTML]="domain.expired? '&check;' : ''"></td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>EPP status</th>
                <td mat-cell *matCellDef="let domain" [innerHTML]="domain.status.join(' ')"></td>
            </ng-container>

            <ng-container matColumnDef="ns_group">
                <th mat-header-cell *matHeaderCellDef>NS group</th>
                <td mat-cell *matCellDef="let domain" [innerHTML]="domain.ns_group"></td>
            </ng-container>

            <ng-container matColumnDef="flags">
                <th mat-header-cell *matHeaderCellDef>Flags</th>
                <td mat-cell *matCellDef="let domain" [innerHTML]="domain.flags.join(' ')"></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let _; columns: columnsToDisplay"></tr>
        </table>
    </div>
} @else if (hasSearched() && !busy()) {
    <div id="no_matches">No matching domains found</div>
}
